module.exports = __webpack_public_path__ + "img/EE11319532.198cf72c.png";